import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { HoverDropdown, HoverDropdownItem } from './styled'
import { DropdownToggle, DropdownMenu } from 'reactstrap'

class CatalogCardPriceWrapper extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            dropdownOpen: false,
        }

        this.toggle = this.toggle.bind(this)
        this.onMouseEnter = this.onMouseEnter.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)
    }

    toggle() {
        this.setState((prevState) => ({
            dropdownOpen: !prevState.dropdownOpen,
        }))
    }
	
    onMouseEnter() {
        this.setState({dropdownOpen: true})
    }
	
    onMouseLeave() {
        this.setState({dropdownOpen: false})
    }

    componentWillMount() {
        const list = this.props.discount.list.filter((item) => item.active)
        this.setState({list})
    }

    render() {
        const { t } = this.props
        let oldPriceSize = "catalog-price-old"
        let newPriceSize = "catalog-price-new"
        oldPriceSize += this.props.size === 'big' ? " md-font-size" : " xs-font-size"
        newPriceSize += this.props.size === 'big' ? " lg-font-size" : " md-font-size"
        oldPriceSize += this.props.noSpace ? ' no-space' : ''
        newPriceSize += this.props.noSpace ? ' no-space' : ''
        return (
            <React.Fragment>
                {
                    this.state.list.length ? 
                        <HoverDropdown direction='up' className="d-inline-block" onMouseOver={this.onMouseEnter} onMouseLeave={this.onMouseLeave} isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                            <DropdownToggle caret>
                                <div className="catalog-price-wrapper hover">
                                    <div
                                        className={`${oldPriceSize}
		${this.props.oldPrice && Number(this.props.oldPrice) > Number(this.props.newPrice) ? '' : ' d-none'}
		`}
                                    >
                                        {this.props.oldPrice || 0} {t('currency-' + this.props.currency)}
                                    </div>
                                    <div className={newPriceSize}>{this.props.newPrice || 0} {t('currency-' + this.props.currency)}</div>
                                </div>
                            </DropdownToggle>
                            <DropdownMenu>
                                {
                                    this.state.list.map((item, index) => (
                                        <HoverDropdownItem key={index} className={'md-font-size'} disabled>{item.title}: {item.amount} %</HoverDropdownItem>
                                    ))
                                }
                            </DropdownMenu>
                        </HoverDropdown>
                        :
                        <div className="catalog-price-wrapper">
                            <div
                                className={`${oldPriceSize}
		${this.props.oldPrice && Number(this.props.oldPrice) > Number(this.props.newPrice) ? '' : ' d-none'}
		`}
                            >
                                {this.props.oldPrice || 0} {t('currency-' + this.props.currency)}
                            </div>
                            <div className={newPriceSize}>{this.props.newPrice || 0} {t('currency-' + this.props.currency)}</div>
                        </div>
                }
            </React.Fragment>
        )
    }
}

CatalogCardPriceWrapper.propTypes = {
    t: PropTypes.func,
    oldPrice: PropTypes.number,
    newPrice: PropTypes.number,
    currency: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    discount: PropTypes.object,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.any,
    ]),
    noSpace: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.any,
    ]),
}

export default withTranslation()(CatalogCardPriceWrapper)



// WEBPACK FOOTER //
// ./src/components/Catalog/CatalogCardPriceWrapper.jsx